import { useTranslation } from 'react-i18next';
import { ReactComponent as TranslateIcon } from '../../assets/translation.svg';
import styles from './PublicationTranslateButton.module.scss';

const PublicationTranslateButton = ({
  isTranslated = false,
  isBulk = false,
  isLoading = false,
  onToggle,
}) => {
  const { t } = useTranslation();

  const label = isLoading
    ? t('Translating')
    : isTranslated
    ? t('Original')
    : isBulk
    ? t('Translate all')
    : t('Translate');

  return (
    <button
      type="button"
      className={`${styles.btn} ${isTranslated ? styles.active : ''} ${isLoading ? styles.loading : ''}`}
      onClick={() => !isLoading && onToggle?.(!isTranslated)}
      aria-pressed={isTranslated}
      aria-label={label}
      disabled={isLoading}
    >
      <TranslateIcon
        className={styles.icon}
        aria-hidden="true"
      />
      <span>{label}</span>
    </button>
  );
};

export default PublicationTranslateButton;
